import {
  asyncActionFinish,
  asyncActionError,
} from '../../../../app/common/reduxs/async/asyncActions';
import {
  absencesGet,
  absenceAdd,
  absenceEdit,
  absenceGet,
  absenceDelete,
} from './reduxAction';
import { ASYNC_ACTION_START } from '../../../../app/common/reduxs/async/asyncConstant';
import { checkErr } from '../../../../app/common/helpers/checkRes';
import { fetchFunc } from '../../../../app/common/helpers/fetchHelpers';
import { toastr } from 'react-redux-toastr';

export const getAbsences = ({
  auth,
  history,
  itemPerPage,
  currentPage,
  searchText,
  yearFilter,
  semFilter,
  year,
  sem,
}) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getAbsences' });
    const formData = new FormData();
    formData.append('itemPerPage', itemPerPage ? itemPerPage : 10);
    formData.append('currentPage', currentPage);
    formData.append('searchText', searchText);
    if (year) formData.append('year', year);
    if (sem) formData.append('sem', sem);
    try {
      const res = await fetchFunc(
        'gets',
        auth,
        history,
        'absence/',
        formData,
        dispatch
      );
      const items = res.items;
      const total = res.total;
      const jenjangs = res.jenjangs;
      const kelass = res.kelass;
      const years = res.years;
      const sems = res.sems;
      const search = {
        currentPage,
        searchText,
        itemPerPage: itemPerPage ? itemPerPage : 10,
        yearFilter,
        semFilter,
      };
      dispatch(
        absencesGet({ total, items, search, jenjangs, kelass, years, sems })
      );
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const getAddOptions = ({ auth, history }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getAddOptions' });
    const formData = new FormData();
    try {
      const res = await fetchFunc(
        'get',
        auth,
        history,
        'absence/add-options/',
        formData,
        dispatch
      );
      const gurus = res.gurus;
      const jenjangs = res.jenjangs;
      const kelass = res.kelass;
      const years = res.years;
      const sems = res.sems;
      dispatch(absenceGet({ gurus, jenjangs, kelass, years, sems }));
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const addAbsence = ({ auth, history, values }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'addAbsence' });
    const formData = new FormData();
    formData.append('absence', values.absence);
    try {
      const res = await fetchFunc(
        'add',
        auth,
        history,
        'absence/add/',
        formData,
        dispatch
      );
      const absence = res?.absence;

      if (absence) {
        dispatch(absenceAdd(absence));
        history.push('/administrasi/absensi/' + absence.id);
      }
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const getAbsence = ({
  auth,
  history,
  id,
  jenjang,
  kelas,
  year,
  sem,
}) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getAbsence' });
    const formData = new FormData();
    formData.append('absenceId', `${jenjang}-${kelas}-${year}-${sem}`);
    try {
      const res = await fetchFunc(
        'get',
        auth,
        history,
        'absence/detail/' + id,
        formData,
        dispatch
      );
      const absence = res.absence;
      const gurus = res.gurus;
      const jenjangs = res.jenjangs;
      const kelass = res.kelass;
      const years = res.years;
      const sems = res.sems;
      const studentAbsences = res.studentAbsences;

      dispatch(
        absenceGet({
          absence,
          gurus,
          jenjangs,
          kelass,
          years,
          sems,
          studentAbsences: { id, studentAbsences },
        })
      );
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const editAbsence = ({ auth, history, values }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'editAbsence' });
    const formData = new FormData();
    formData.append('absences', JSON.stringify(values.absences));
    try {
      const res = await fetchFunc(
        'edit',
        auth,
        history,
        'absence/edit/' + values.classyearId,
        formData,
        dispatch
      );
      const studentAbsences = res?.studentAbsences;
      const classyearId = res?.classyearId;

      if (studentAbsences) {
        toastr.success('Success', 'Absensi berhasil disimpan.');
        dispatch(absenceEdit({ classyearId, studentAbsences }));
      }
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const deleteAbsenceSem = ({ auth, history, id, absenceId }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'deleteAbsenceSem' });
    const formData = new FormData();

    try {
      const res = await fetchFunc(
        'delete',
        auth,
        history,
        'absence/delete/' + absenceId,
        formData,
        dispatch
      );
      const absence = res?.absence;
      if (absence) {
        dispatch(absenceDelete({ id }));
        history.push('/administrasi/absensi');
      }
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};

export const deleteAbsences = ({ auth, history, id }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'deleteAbsences' });
    const formData = new FormData();
    try {
      const res = await fetchFunc(
        'delete',
        auth,
        history,
        'absence/delete/all',
        formData,
        dispatch
      );
      const absence = res.absence;
      dispatch(absenceDelete(absence));
      history.push('/administrasi/absensi');
      dispatch(asyncActionFinish());
    } catch (err) {
      checkErr(err);
      dispatch(asyncActionError());
    }
  };
};
